import { ApiService } from "@core/api/api-service";
import { MedicalProfession } from "@domain/localization/country";

import { DemoRequestFormData } from "@ui/pages/prospect/campaigns/demo-request/demo-request-form";
import { InviteYourPtFormData } from "@ui/pages/prospect/campaigns/invite-your-pt/invite-your-pt-form";

type InviteYourPtRequestDto = {
	patient: {
		firstName: string;
		lastName: string;
	};
	pt: {
		countryCode: string;
		firstName: string;
		lastName: string;
		email?: string;
		phoneNumber: string;
		postalCode: string;
		medicalProfession?: MedicalProfession;
	};
};

export class ProspectRequestService {
	constructor(private readonly apiService: ApiService) {}

	async sendDemoRequest(demoRequest: DemoRequestFormData): Promise<void> {
		await this.apiService.post("/prospects/pt", demoRequest);
	}

	async sendInviteYourPTRequest(inviteYourPtRequest: InviteYourPtFormData): Promise<void> {
		await this.apiService.post("/prospects/patient", inviteYourPtRequestDtoFromFormData(inviteYourPtRequest));
	}
}

const inviteYourPtRequestDtoFromFormData = ({
	patientFirstName,
	patientLastName,
	...pt
}: InviteYourPtFormData): InviteYourPtRequestDto => ({
	patient: { firstName: patientFirstName, lastName: patientLastName },
	pt,
});
